import { routeTree } from "./routeTree.gen";
import { CultureProvider, ThemeProvider } from "@vintecc/components";
import Background from "./components/BackgroundComponent/BackgroundComponent";
import { Link, RouterProvider, createRouter } from "@tanstack/react-router";
import { useStyledFavicon } from "@/shared/hooks/useStyledFavicon";
import ENV from "./env";
import { appI18n } from "./services/culture/i18n";
import { COMMON_TRANSLATIONS } from "./services/culture/common.translations";
import { ModuleTranslationsContext } from "./services/culture/moduleTranslations";
import { useCultureProviderState } from "./services/culture/useCultureProviderState";
import type { InitialCulture } from "./services/culture/bootstrap";

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const defaultTheme = {
  "login-color": "var(--component-button-filled-default-background)",
};

type AppProps = {
  initialCulture?: InitialCulture;
};

const App = ({ initialCulture }: AppProps) => {
  useStyledFavicon({ rootApiPath: ENV.API_SERVER, fallbackFaviconUrl: "/favicon.ico" });
  const { locale, translations, isCommonReady, ensureModuleLoaded, isModuleLoaded } = useCultureProviderState(initialCulture);

  return (
    <ThemeProvider theme={{ custom: defaultTheme }} linkComponent={Link}>
      <ModuleTranslationsContext.Provider value={{ ensureModuleLoaded, isModuleLoaded }}>
        <CultureProvider locale={locale} translations={translations} i18n={appI18n}>
          {isCommonReady ? (
            <>
              <Background />
              <RouterProvider router={router} basepath={ENV.BASE_PATH} />
            </>
          ) : (
            <div className="min-h-screen flex items-center justify-center text-sm text-grey-500">{COMMON_TRANSLATIONS["common.loading"]}</div>
          )}
        </CultureProvider>
      </ModuleTranslationsContext.Provider>
    </ThemeProvider>
  );
};

export default App;
